import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';
import { Button } from 'src/@/components/ui/button';
import { Switch } from 'src/@/components/ui/switch';
import { Textarea } from 'src/@/components/ui/textarea';

export default function QuestionRow({
    icon,
    titulo,
    descricao,
    state,
    essencialDisabled,
    qualificatoriaDisabled,
    onChange,
    onDelete,
    // SPIN-specific props. When spinField is set, this pergunta participates
    // in the Lais search-qualification flow and exposes an editable script.
    spinField,
    defaultScript,
}) {
    const ativa = !!state?.ativa;
    const qualificatoria = !!state?.qualificatoria;
    const script = state?.script ?? '';
    const isSpin = Boolean(spinField);
    const [scriptOpen, setScriptOpen] = useState(false);

    return (
        <div className="py-3">
            <div className="grid grid-cols-[auto_1fr_auto_auto_auto_auto] items-center gap-4">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-gray-50 shrink-0">
                    <Iconify icon={icon} width={18} className="text-gray-600" />
                </div>
                <div className="min-w-0">
                    <div className="flex items-center gap-2">
                        <p className="text-sm font-medium text-gray-900 truncate">{titulo}</p>
                        {isSpin && (
                            <Badge variant="outline" className="text-[10px] font-semibold uppercase tracking-wider text-violet-700 border-violet-200 bg-violet-50">
                                SPIN
                            </Badge>
                        )}
                    </div>
                    {descricao && <p className="text-xs text-gray-500 line-clamp-2">{descricao}</p>}
                </div>
                <div className="flex flex-col items-center gap-1">
                    <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Essencial</span>
                    <Switch
                        checked={ativa}
                        disabled={essencialDisabled}
                        onCheckedChange={(value) => onChange({ ativa: value })}
                    />
                </div>
                <div className="flex flex-col items-center gap-1">
                    <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Qualificatória</span>
                    <Switch
                        checked={qualificatoria}
                        disabled={qualificatoriaDisabled}
                        onCheckedChange={(value) => onChange({ qualificatoria: value })}
                    />
                </div>
                {isSpin ? (
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        onClick={() => setScriptOpen((v) => !v)}
                        title={scriptOpen ? 'Fechar script' : 'Editar script'}
                        className={`rounded-xl ${scriptOpen ? 'text-[#7C3AED] bg-violet-50' : 'text-gray-400 hover:text-[#7C3AED] hover:bg-violet-50'}`}
                    >
                        <Iconify icon={scriptOpen ? 'eva:chevron-up-outline' : 'mdi:message-text-outline'} width={16} />
                    </Button>
                ) : (
                    <div className="w-10" />
                )}
                {onDelete ? (
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        onClick={onDelete}
                        className="rounded-xl text-gray-400 hover:text-red-600 hover:bg-red-50"
                    >
                        <Iconify icon="eva:trash-2-outline" width={16} />
                    </Button>
                ) : (
                    <div className="w-10" />
                )}
            </div>
            {isSpin && scriptOpen && (
                <div className="mt-3 ml-[52px] mr-[52px] flex flex-col gap-1.5">
                    <label className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
                        Script da Lais <span className="text-gray-400 normal-case tracking-normal">(campo_faltante: {spinField})</span>
                    </label>
                    <Textarea
                        value={script}
                        onChange={(e) => onChange({ script: e.target.value })}
                        placeholder={defaultScript || ''}
                        rows={2}
                        className="rounded-xl border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20"
                    />
                    {defaultScript && (
                        <p className="text-xs text-gray-400">Padrão: <em>{defaultScript}</em></p>
                    )}
                </div>
            )}
        </div>
    );
}
